







import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { capitalizeNameHelper } from '@/heplers/stringHelpers';
import { BadgeProperties, IOSBadgeProperties } from '@/templates/Tree';
import { BadgesType } from '@/templates/NewRoutes';

@Component({
  filters: {
    capitalize: capitalizeNameHelper,
  },
})
export default class Badges extends Vue {
  @Prop() BadgeProrerties: IOSBadgeProperties | BadgeProperties;

  get badges() {
    const attributes: string[] = Object.keys(this.BadgeProrerties);
    const badges: BadgesType[] = Object.values(BadgesType);
    let filteredResult = attributes.filter((attr) => badges.includes(<BadgesType>attr));

    return filteredResult.reduce((acc, key) => {
      return {
        ...acc,
        //@ts-expect-error: implicitly has an 'any' type because expression of type 'string' can't be used to index type 'IOSBadgeProperties | BadgeProperties'.
        [key]: this.BadgeProrerties[key],
      };
    }, {});
  }
}
